module.exports = __webpack_public_path__ + "img/util-tab-4.6cf3e16b.svg";